import { Inject, Injectable, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LinkService {
  private canonicalLink = this.document.createElement('link');

  constructor(private rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {}

  addTag(url: string) {
    try {
      this.canonicalLink.setAttribute('rel', 'canonical');
      this.canonicalLink.setAttribute('href', url);
      this.document.head.prepend(this.canonicalLink);
    } catch (e) {
      console.error(e);
    }
  }

  removeTag() {
    try {
      const linkTags = this.document.querySelectorAll('link[rel=canonical]');
      linkTags.forEach((tag) => {
        this.document.head.removeChild(tag);
      });
    } catch (e) {
      console.error(e);
    }
  }

  updateCanonicalLink(newCanonicalUrl: string) {
    this.removeTag();
    this.addTag(`${environment.baseUrl}/${newCanonicalUrl}`);
  }
}
